import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getUsage } from "@/lib/usage.functions";
import { getStripeEnvironment } from "@/lib/stripe";
import { useAuth } from "@/hooks/useAuth";

export function usePremium() {
  const { user, loading } = useAuth();
  const usage = useServerFn(getUsage);
  const { data } = useQuery({
    queryKey: ["usage", getStripeEnvironment()],
    queryFn: () => usage({ data: { environment: getStripeEnvironment() } }),
    enabled: !!user && !loading,
    staleTime: 30_000,
  });
  return {
    isPremium: !!data?.isPremium,
    isPro: !!data?.isPro,
    ready: !loading && (!user || !!data),
  };
}
